import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";

import { FormattedMessage, useIntl } from "react-intl";
import { addSection, editSection, getSection } from "store/actions";
import Loader from "components/shared/Loader";
import { useState } from "react";

import SaveChangesButton from "components/shared/SaveChangesButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import ImageUpload from "components/shared/ImageUpload";
import { isObjectNotEmpty } from "helpers/functions";

const CeoMessage = () => {
  const { formatMessage, locale } = useIntl();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const dispatch = useDispatch();
  const { loading, error, section } = useSelector((state) => state.section);

  const {
    register,
    reset,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // get single page by slug
  useEffect(() => {
    dispatch(
      getSection({
        page: "about",
        slug: "mangerMessage",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    reset(section);
    setSelectedImage({
      preview: null,
      path: section?.image,
    });
  }, [reset, section]);

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = selectedImage?.path;
    dispatch(
      editSection({
        slug: "mangerMessage",
        page: "about",
        data: { section: data },
      })
    );
    // if (isObjectNotEmpty(section)) {
    // } else {
    //   const newData = { section: { title: "mangerMessage", ...data } };
    //   console.log("data=====>", data);

    //   dispatch(
    //     addSection({
    //       page: "about",
    //       data: newData,
    //     })
    //   );
    // }
  };

  useEffect(() => {
    setValue(`sectionTitle.ar`, section?.sectionTitle?.ar || "");
    setValue(`sectionTitle.en`, section?.sectionTitle?.en || "");
    setValue(`sectionDescription.ar`, section?.sectionDescription?.ar || "");
    setValue(`sectionDescription.en`, section?.sectionDescription?.en || "");
  }, [section, setValue]);
  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"CeoMessage"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={12} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"image"} />
                    </h5>
                    <ImageUpload
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </Col>
              </Row>

              <div className="add-multi-component mb-5">
                <Row>
                  {/* Arabic Title Input */}
                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"arabic-language"} />){" "}
                        </>
                      </h5>
                      <input
                        name={`sectionTitle.ar`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionTitle.ar`, {
                          required: formatMessage({
                            id: "requiredField",
                          }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 50,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionTitle?.ar?.message && (
                        <p className="error-hint">
                          {errors?.sectionTitle?.ar?.message}
                        </p>
                      )}
                    </div>
                  </Col>
                  {/* =========================================================================================== */}

                  {/* English Title Input */}

                  <Col lg={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"title"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"english-language"} />){" "}
                        </>
                      </h5>
                      <input
                        name={`sectionTitle.en`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionTitle.en`, {
                          required: formatMessage({
                            id: "requiredField",
                          }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 50,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionTitle?.en?.message && (
                        <p className="error-hint">
                          {errors?.sectionTitle?.en?.message}
                        </p>
                      )}
                    </div>
                  </Col>
                  {/* =========================================================================================== */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"arabic-language"} />){" "}
                        </>
                      </h5>
                      <textarea
                        name={`sectionDescription.ar`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionDescription.ar`, {
                          required: formatMessage({
                            id: "requiredField",
                          }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 250,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionDescription?.ar?.message && (
                        <p className="error-hint">
                          {errors?.sectionDescription?.ar?.message}
                        </p>
                      )}
                    </div>
                  </Col>

                  {/* =========================================================================================== */}

                  <Col xxl={6} xs={12}>
                    <div className="form-group">
                      <h5>
                        <FormattedMessage id={"description"} />

                        <>
                          {" "}
                          (<FormattedMessage id={"english-language"} />){" "}
                        </>
                      </h5>
                      <textarea
                        name={`sectionDescription.en`}
                        type="text"
                        className="form-control form-outline"
                        {...register(`sectionDescription.en`, {
                          required: formatMessage({
                            id: "requiredField",
                          }),
                          minLength: {
                            value: 3,
                            message: formatMessage({ id: "minLength" }),
                          },
                          maxLength: {
                            value: 250,
                            message: formatMessage({ id: "maxLength" }),
                          },
                        })}
                      />

                      {errors?.sectionDescription?.en?.message && (
                        <p className="error-hint">
                          {errors?.sectionDescription?.en?.message}
                        </p>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
              <SaveChangesButton />
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CeoMessage;
